"use client";

import { loadStripe } from "@stripe/stripe-js";
import { env } from "~/env.mjs";

let stripePromise: ReturnType<typeof loadStripe> | null = null;

export function getStripePromise() {
  if (!stripePromise) {
    stripePromise = loadStripe(env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY).catch(
      (error: unknown) => {
        stripePromise = null;
        throw error;
      },
    );
  }

  return stripePromise;
}
